import isPortalSpecificObjectType from 'customer-data-objects/crmObject/isPortalSpecificObjectType';
import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('crm-records-ui');
export const getObjectTypeIdForMetrics = objectTypeId => {
  return isPortalSpecificObjectType(objectTypeId) ? 'custom_object' : objectTypeId;
};